import { render, staticRenderFns } from "./VuseLogo.vue?vue&type=template&id=5f4a1b88&"
import script from "./VuseLogo.vue?vue&type=script&lang=js&"
export * from "./VuseLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports